import * as React from 'react'
import PickingListCard from './PickingListCard'
import { PickingListRowShape, StagedPick } from '../../api/api_data_types'

interface PickingListCardsViewProps {
  data?: PickingListRowShape[]
  currentUser: { username: string }
  isLoading: boolean
  changedQuantities: Record<string, StagedPick>
  setChangedQuantities: React.Dispatch<React.SetStateAction<Record<string, StagedPick>>>
}

export default function PickingListCardsView({
  data,
  currentUser,
  isLoading,
  changedQuantities,
  setChangedQuantities,
}: PickingListCardsViewProps) {
  return (
    <div className="picking-list-cards-view">
      {isLoading && (
        <div className="text-center">
          <i className="fa fa-spinner fa-spin fa-2x" />
        </div>
      )}
      {!isLoading && data && (
        <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xl-4">
          {data.map(row => (
            <div key={row.key} className="col mb-4">
              <PickingListCard
                row={row}
                currentUser={currentUser}
                changedQuantities={changedQuantities}
                setChangedQuantities={setChangedQuantities}
                className="h-100"
              />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
